import Image from '~/shared/Image';
import React, { useEffect, useState } from 'react';
import { Box, Pressable } from 'native-base';

export type ImagesGalleryProps = {
    imagesProp: ImagesProp[];
    width: string;
};

interface ImagesProp {
    id: number;
    label: string;
    thumb: string;
    url: string;
}

const CompactImagesGallery = ({
    imagesProp,
    width,
}: ImagesGalleryProps) => {

    const [images, setImages] = useState<ImagesProp[] | null>(null);
    const [firstImage, setFirstImage] = useState<number | undefined | null>(null);

    useEffect(() => {

        setImages(imagesProp);
        setFirstImage(imagesProp[0]?.id);
    }, []);

    const selectImage = (id: number): void => {

        if (!images) {
            return;
        }

        const selectedImageIndex = images?.findIndex(image => image.id === id);

        if (selectedImageIndex !== -1) {
            const updatedImages = [
                images[selectedImageIndex],
                ...images.slice(0, selectedImageIndex),
                ...images.slice(selectedImageIndex + 1)
            ];

            setImages(updatedImages);
            setFirstImage(updatedImages[0]?.id);
        }
    };

    const _width = parseFloat(width);

    return (
        images && (
            <>
                <Image
                    w={_width / 2}
                    h={_width / 2}
                    uri={`${images[0].url}`}
                    position={'fixed'}
                    opacity={.3}
                    borderTopLeftRadius={8}
                />
                <Image
                    w={_width / 2}
                    h={_width / 2}
                    uri={`${images[0].url}`}
                    position={'fixed'}
                    marginLeft={_width / 2}
                    opacity={.3}
                    borderTopRightRadius={8}
                />
                { images.map((image, index) => {

                    if (firstImage === image.id) {
                        return (
                            <Pressable onPress={() => selectImage(image.id)} key={index}>
                                <Image
                                    key={image.id}
                                    w={_width / 2}
                                    h={_width / 2}
                                    marginLeft={images.length === 1 ? _width / 4 : 0}
                                    uri={`${image.url}`}
                                />
                            </Pressable>
                        );
                    }
                })}

                <Box
                    flexDirection={'row'}
                    flexWrap={'wrap'}
                    w={_width / 2}
                >
                    { images.map((image, index) => {

                        if (firstImage !== image.id) {
                            return (
                                <Pressable onPress={() => selectImage(image.id)} key={index}>
                                    <Image
                                        key={image.id}
                                        w={_width / 4}
                                        h={_width / 4}
                                        uri={`${image.url}`}
                                    />
                                </Pressable>
                            );
                        }
                    })}
                </Box>
            </>
        )
    );
};

export default CompactImagesGallery;
